import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import axiosInstance from "../components/api/axiosInstance";
import AddProjectPayment from "./AddProjectPayment";

function AddProjectPaymentPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const projectId = parseInt(id, 10);

  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadProject = async () => {
      try {
        setLoading(true);
        const res = await axiosInstance.get(`/projects/${projectId}`);
        const p = res.data?.data || res.data;
        setProject(p || null);
      } catch (err) {
        console.error("Error fetching project for Add Payment:", err);
        alert("Failed to load project details.");
        setProject(null);
      } finally {
        setLoading(false);
      }
    };

    loadProject();
  }, [projectId]);

  const handleCancel = () => {
    navigate(`/projects/${projectId}/view`);
  };

  return (
    <div className="viewlead-container">
      <div className="viewlead-header">
        <button
          type="button"
          className="viewlead-back-link"
          onClick={() => navigate(-1)}
        >
          <FaArrowLeft /> Back
        </button>
      </div>
      {loading ? (
        <div>Loading payment form...</div>
      ) : project ? (
        <AddProjectPayment
          projectId={projectId}
          project={project}
          onSuccess={() => {
            const refresh = Date.now();
            navigate(`/projects/${projectId}/view?refresh=${refresh}`);
          }}
          onCancel={handleCancel}
        />
      ) : (
        <div>Project not found.</div>
      )}
    </div>
  );
}

export default AddProjectPaymentPage;

